export default __webpack_public_path__ + "static/media/ZingCreateActionH3@3x.2737f23b.png";